const o = (e) => /^https?:\/\//i.test(e);
function l(e) {
  const { children: n, target: r } = e;
  if (!(!n || typeof n != "string" || r !== "_blank"))
    return `${n}. ${window.jQuery ? $.__("Opens in a new tab") : "Opens in a new tab"}.`;
}
function s(e) {
  const { "aria-label": n, children: r, href: t, rel: a, target: i } = e;
  return {
    ...e,
    // Don't add `href` if there's no `href` - it affects a11y and styling
    href: t || void 0,
    // Try to ensure a11y for links that open in a new tab
    "aria-label": n || l({ children: r, target: i }),
    // Add proper relationship for external links
    rel: a || (o(t || "") ? "external nofollow noopener noreferrer" : void 0)
  };
}
export {
  s as e,
  o as i
};
//# sourceMappingURL=enhance-anchor-props-DgCJ7ag3.mjs.map
